export const TAB_IDS = {
  DASHBOARD: "dashboard",
  REQUESTS: "requests",
  MEALS: "meals",
  OVERRIDE: "override",
  APPROVERS: "approvers",
  SEND_EMAILS: "send-emails"
};
